<template>
  <client-only>
    <div>
      <v-container
        v-if="!$fetchState.pending"
        :class="displayType != 2 ? 'py-0' : ' px-0'"
      >
        <div v-if="displayRecommended">
          <v-row v-if="!$fetchState.pending && headerDisplay">
            <v-col cols="12" class="text-center">
              <v-row>
                <v-col class="d-flex flex-column">
                  <h2 class="mt-4 mb-2 primary--text display-36-24">
                    מצאנו {{ jobCount }} משרות בדיוק בשבילך
                  </h2>
                  <p
                    class="primary--text display-24-18 mb-0"
                    v-text="t('jobs.additionalJobsSun')"
                  ></p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- carousel display  -->
          <v-row
            v-if="displayType === 3"
            class="recommended-jobs-carousel flex-column"
            justify="center"
          >
            <v-row
              justify="center"
              v-if="!$fetchState.pending && displayMoreJobsHeader"
            >
              <p class="text-center display-16 font-weight-medium py-2">
                יש לנו עוד {{ jobCount }} משרות מומלצות עבורך
              </p>
            </v-row>
            <v-carousel
              v-model="carouselModel"
              :cycle="true"
              :continuous="false"
              :show-arrows="false"
              :height="$vuetify.breakpoint.xsOnly ? '300px' : '310px'"
              light
              hide-delimiter-background
              id="jobs-carousel"
              :interval="3000"
            >
              <v-carousel-item v-for="(job, i) of recommendedJobs" :key="i">
                <RecommenderJobItem
                  class="job-item-carousel"
                  :job="job"
                  :currentPage="currentPage"
                  :job-index="i"
                  :userIsLogged="CurrentUser ? true : false"
                  :forwardToJobPage="forwardToJobPage"
                  :displayJobDescription="displayJobDescription"
                />
              </v-carousel-item>
            </v-carousel>
          </v-row>
          <!-- Slider Display  -->
          <v-row
            justify="center"
            class="recommended-jobs flex-column"
            v-if="displayType === 0"
          >
            <v-col class="py-0" cols="12">
              <v-slide-group
                multiple
                show-arrows
                id="recommended-jobs-slider"
                center-active
              >
                <v-slide-item
                  v-for="(job, i) of recommendedJobs"
                  :key="i"
                  v-slot="{ active, toggle }"
                  :value="job.Code"
                >
                  <RecommenderJobItem
                    class="job-item-slider"
                    :job="job"
                    :currentPage="currentPage"
                    :job-index="i"
                    :userIsLogged="CurrentUser ? true : false"
                    :forwardToJobPage="forwardToJobPage"
                    :displayJobDescription="displayJobDescription"
                  />
                </v-slide-item>
              </v-slide-group>
            </v-col>
            <!-- <v-col cols="12" :class="!$fetchState.pending ? 'my-6 py-6' : ''" ></v-col> -->
            <v-spacer
              :class="!$fetchState.pending ? 'my-6 py-6' : ''"
            ></v-spacer>
          </v-row>

          <!-- Grid Display  -->
          <v-row
            v-if="displayType === 1"
            class="recommended-jobs-grid"
            :justify="jobCount === 1 ? 'center' : 'space-between'"
          >
            <!-- header -->
            <v-col cols="12">
              <v-row>
                <v-col class="d-flex flex-column px-0">
                  <h4
                    class="display-32 mt-8 mb-0 primary--text font-weight-medium"
                    v-text="t('jobs.additionalJobs')"
                  />
                  <p
                    class="display-16 font-weight-medium mb-1"
                    v-text="t('jobs.additionalJobsSun')"
                  ></p>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              :md="maxJobs === 1 ? '' : 6"
              class="pa-0 mb-4 grid-item-box"
              v-for="(job, i) of recommendedJobs"
              :key="i"
            >
              <RecommenderJobItem
                class="job-item-grid"
                :job="job"
                :currentPage="currentPage"
                :job-index="i"
                :userIsLogged="CurrentUser ? true : false"
                :forwardToJobPage="forwardToJobPage"
                :displayJobDescription="displayJobDescription"
              />
            </v-col>
          </v-row>

          <!-- Regular job item display -->
          <v-row
            v-if="displayType === 2"
            class="flex-column"
            id="regular-display"
          >
            <v-col
              v-for="(item, i) in recommendedJobs"
              :key="item.Code"
              class="pt-0 pb-6 jobList_vacancy"
            >
              <JobItem
                :job-details="item"
                class="job-item"
                :recomended-job="item.JobInfo.IsRecommender"
                :job-index="i"
                :class="{ preferred: item.JobInfo.Preferred }"
                :isSingleJob="false"
                :ssasource="5"
                :currentPage="currentPage"
              />
            </v-col>
          </v-row>

          <!-- display more jobs section on cv confirmation popup -  {displayMoreJobsBtn  && !$fetchState.pending} -->
          <v-row
            class="px-3 mt-2 display-more"
            v-if="displayMoreJobsBtn && !$fetchState.pending"
          >
            <v-col align-self="center" class="pa-0">
              <v-row>
                <v-col
                  cols="12"
                  sm="7"
                  class="text-right pa-0"
                  :class="
                    $vuetify.breakpoint.xsOnly
                      ? 'text-center pb-2'
                      : 'text-right'
                  "
                >
                  <p class="font-weight-medium display-18 d-block">
                    יש לנו משרות נוספות עבורך
                  </p>
                </v-col>
                <v-col cols="12" sm="5" class="text-center pa-0">
                  <v-btn
                    color="primary"
                    rounded
                    :max-width="'170px'"
                    :min-width="'150px'"
                  >
                    מעניין אותי
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col align-self="center">
              <v-btn
                color="primary"
                rounded
                class="px-3"
                :width="$vuetify.breakpoint.smAndDown ? 120 : 130"
              >
                מעניין אותי
              </v-btn>
            </v-col> -->
          </v-row>
        </div>
      </v-container>
    </div>
  </client-only>
</template>

<script>
import CurrentUser from '@/components/mixins/CurrentUser';
import RecommenderJobItem from '@/components/Recommender/RecommenderJobItem';
import JobItem from '@/components/Jobs_List/Jobs_On_Drushim/Job_Item/JobItem.vue';
import gtm from '@/lib/gtm';
import drushim_lodash from 'lodash';

export default {
  mixins: [CurrentUser],
  components: { RecommenderJobItem, JobItem },
  data() {
    return {
      selected: [],
      recommendedJobs: [],
      carouselModel: 0,
    };
  },
  props: {
    /**
    // @param {String} currentPage   relevant only for recommended jobs - The current page recommender displayes @values recommender_CV Popup| recommender_HomePage| recommender_Single Job | recommender_Personal Area| recommender_Search Results
    // @param {Number} maxJobs  Max number of jobs to fetch from API. according to page UI
    // @param {Boolean} forwardToJobPage  In case we redirect cv button to a single job page , no cv button
    // @param {Number } displayType   UI display type - slider / grid  / regulart -  @param {maxJobs=1} will display in slider
    // @param {Boolean} displayJobDescription   display the job description
    // @param {Boolean} displayMoreJobsBtn   Add link to  recommended jobs page
    // @param {Boolean} headerDisplay   Display header above slider
    // @param {Boolean} displayMoreJobsHeader   Display header above carousel
    */
    currentPage: {
      type: String,
      required: false,
      default: '',
    },
    maxJobs: {
      type: Number,
      required: false,
      default: 1,
    },
    forwardToJobPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** 0 - slider
     /* 1 - grid
     /* 2 - regular job item
     /* 3 - carousel
     */
    displayType: {
      type: Number,
      required: false,
      default: 1,
    },
    displayJobDescription: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayMoreJobsBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayMoreJobsHeader: {
      type: Boolean,
      required: false,
      default: false,
    },

    headerDisplay: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    jobCount() {
      if (this.recommendedJobs) {
        return this.recommendedJobs.length;
      } else return false;
    },
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },
    displayRecommended() {
      if (!this.$fetchState.pending && !this.recommendedJobs?.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    currUserId() {
      return this.CurrentUser ? this.CurrentUser.UserId : false;
    },
    UserHashId() {
      return this.$cookies.get('drushimSSA_UserHashId');
    },
  },
  methods: {
    fireGtmEvent() {
      // all impression
      const dataLayer = {
        category: 'recommender',
        event: 'drushim_recommender',
        action: 'recommender impression',
        cd70: this.currentPage,
      };
      // gtm(_dataLayer);
      gtm(dataLayer);
    },
  },
  watch: {
    // '$route.query': '$fetch',
  },
  fetchOnServer: false,
  async fetch() {
    if (process.client) {
      /**
       * @param {string} currUserId - A string param from user profile
       * @param {string} UserHashId - A Cookie string param  drushimSSA_UserHashId
       *
       * If user is logged in using @param{User Id} value otherwise  @param {drushimSSA_UserHashId} cookie
       */
      let userId = this.currUserId
        ? this.currUserId
        : this.UserHashId
        ? this.UserHashId
        : false;

      try {
        if (userId) {
          const { data } = await this.$axios.get(
            `${process.env.baseUrl}/api/recommender/userbasedrecommendation/${userId}/?maxjobs=${this.maxJobs}`
          );
          if (data.IsError) {
            throw data.Errors;
          }

          if (data.ResultList) {
            this.recommendedJobs = data.ResultList;
          }

          /**push recommended jobs to cookies */
          const options = {
            // path: window.location.pathname,
            // maxAge: 60,
            sameSite: 'Lax',
          };

          let cookieList = [];
          for (let index = 0; index < data.ResultList?.length; index++) {
            const element = data.ResultList[index].Code;
            cookieList.push({
              name: 'drushim-jID-' + element,
              value: element,
              opts: options,
            });
          }
          this.$cookies.setAll(cookieList);

          this.fireGtmEvent();
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>

<style  lang="sass" >
$slide-group-prev-basis: 10px

#recommended-jobs-slider .v-slide-group__prev
  min-width: 30px !important
#recommended-jobs-slider .v-slide-group__next
  min-width: 30px !important
.display-more
  // max-width: 400px
  margin: 0 auto
#recommended-jobs-slider .v-slide-group__next.v-slide-group__next--disabled
  opacity: 0.2
#recommended-jobs-slider .v-slide-group__prev.v-slide-group__prev--disabled
  opacity: 0.2

.recommended-jobs
  max-width: 1132px
  flex-wrap: nowrap
  margin: 0 auto
  @media only screen and (min-width: 900px)
.recommended-jobs-grid
  max-width: 1900px
  flex-wrap: wrap
  margin: 0 auto
// .grid-item-box
//   max-width: 450px

#jobs-carousel .v-btn--icon.v-size--small.v-carousel__controls__item
  height: 12px
  width: 12px
#jobs-carousel .theme--light.v-btn.v-carousel__controls__item
  color: $primary
#jobs-carousel .theme--light.v-btn.v-carousel__controls__item.v-item--active.v-btn--active
  color: $primary
#jobs-carousel .theme--light.v-btn.v-carousel__controls__item.v-item--active.v-btn--active:before
  color: #ff7100
  opacity: 1
  background-color: #ff7100 !important
  left: -1px
  top: 0px
  width: 13px
  height: 13px

// #jobs-carousel .theme--light.v-btn.v-carousel__controls__item.v-item--active
//   color: $primary
// #jobs-carousel .theme--light.v-btn.v-carousel__controls__item.v-item--active:hover:before
//   color: $primary
// .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before
//   opacity: 1
// .v-btn--active:before, .v-btn:hover:before, .v-btn:focus:before
//   background: red

#regular-display .job-item
  position: relative
  border-right: 9px solid #f2f0ef
  z-index: 5

  &.preferred
    border-right: 9px solid $primary

  &.preferred.job-submitted
    border-right: 9px solid $lightGreen

  &.preferred
    border-right: 9px solid $primary

  &.preferred.job-submitted
    border-right: 9px solid $lightGreen
    background-color: $bgGrayJob

  &.detailsIsOpen
    background-color: #f6f7f9

  &.job-submitted
    border-right: 9px solid $lightGreen
    background-color: $bgGrayJob
</style>
